<header id="header" class="transparent">
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-4 col-xs-4 text-left no-padding">
          <div data-toggle="modal" data-target="#menuModal" class="custom-btn">
            <i class="icon-wb stroke R3"></i>menu
          </div>
        </div>
        <div class="col-md-4 col-xs-4 text-center logo-container">
          <a href="/#/home" title="WellBrain">
            <img src="/assets/images/WellBrain_invert.png" alt="WellBrain logo" class="invert">
          </a>
        </div>
      </div>
    </div>
  </header>


// WEBPACK FOOTER //
// /Volumes/Projects/WellBrain_Azure_Web/src/app/components/header/header.component.html